// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ErrorDialog_errorMessage__2l2L-"};